import { Outlet } from 'react-router-dom';
import AuthHeader from './AuthHeader';

const AuthMainLayout = () => {
  
  const handleContextMenu = (e) => {
    e.preventDefault(); // disables right-click menu
  };

  return (
    <>
      <video controls={false} onContextMenu={handleContextMenu} loop={true} autoPlay={true} muted={true}
        style={{
          position: 'fixed',
          zIndex: 0,
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          pointerEvents: 'none', // Optional: disables interaction with video
        }}>
        <source src={process.env.REACT_APP_SECURITY_MOVIE_LINK} />
      </video>
      <div
        style={{
          position: 'fixed',
          zIndex: 1,
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.7)', // Adjust opacity here
          pointerEvents: 'none',
        }}
      />
      {/* Main content */}
      <div className="relative z-10">
        <AuthHeader />
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </>
  );
}
export default AuthMainLayout;